<template>
  <div style="padding-bottom: 150px" class="centered">
    <div class="center" style="">
      <p class="title_">Rateio em andamento</p>
      <div
        class="table-teste"
        v-if="
          (finshedLoad && dataTableOpen.length > 0) ||
          dataTablePending.length > 0
        "
      >
        <el-table
          v-if="btnIsDisable"
          :data="dataTablePending"
          style=""
          :header-cell-style="{ color: '#333' }"
        >
          <el-table-column label="Mês" width="100">
            <template slot-scope="scope">
              <span>{{ dayjs(scope.row.period).format("MM/YYYY") }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Status" width="300">
            <template slot-scope="scope">
              <span>{{
                scope.row.status === constants.status.pending
                  ? "Aguardando rateio"
                  : scope.row.status === constants.status.opened
                  ? "Aberto"
                  : "Aguardando importação"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Ações" width="150">
            <template slot-scope="scope" style="display: flex">
              <el-popover
                placement="top"
                width="300"
                trigger="manual"
                v-model="scope.row.popVisible"
                :ref="'popover' + scope.$index"
              >
                <div class="confirm-items">
                  <div>
                    <b-icon
                      style="
                        margin-left: 10px;
                        margin-right: 10px;
                        color: #e87305;
                      "
                      class="icon-beaut"
                      icon="info-circle-fill"
                      font-scale="1"
                    ></b-icon>
                  </div>
                  <div>
                    <span style="word-break: break-word"
                      >Gerar rateio do período
                      <b>{{ dayjs(scope.row.period).format("MM/YYYY") }}</b
                      >?</span
                    >
                    <p
                      style="
                        word-break: break-word;
                        margin-top: 10px;
                        font-size: 12px;
                      "
                    >
                      Após a atualização o rateio passará a ter o status como
                      ABERTO.
                    </p>
                  </div>
                </div>

                <div style="text-align: right; margin: 0; margin-top: 5px">
                  <el-button
                    style="background: #eaeaea; color: #515151"
                    type="text"
                    :disabled="isLoadingBtnConfirm"
                    @click="
                      () => {
                        scope.row.popVisible = false;
                        isLoadingBtnGenerate = false;
                      }
                    "
                    >cancelar</el-button
                  >
                  <el-button
                    :loading="isLoadingBtnConfirm"
                    @click="
                      generateApportionment(scope.$index, scope.row, scope)
                    "
                    >confirmar</el-button
                  >
                </div>
                <el-button
                  slot="reference"
                  @click="
                    () => {
                      scope.row.popVisible = true;
                      isLoadingBtnGenerate = true;
                    }
                  "
                  :loading="isLoadingBtnGenerate"
                  >Gerar rateio</el-button
                >
              </el-popover>
            </template>
          </el-table-column>
        </el-table>
        <el-table
          :cell-style="{ cursor: 'pointer' }"
          v-else
          :data="dataTableOpen"
          style=""
          :default-sort="{ prop: 'period', order: 'descending' }"
          :header-cell-style="{ color: '#333' }"
          @row-click="handleRowClick"
        >
          <el-table-column label="Mês" width="100" prop="period" sortable>
            <template slot-scope="scope">
              <span>{{ dayjs(scope.row.period).format("MM/YYYY") }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="Valor disponível"
            width="180"
            prop="total_available"
            sortable
          >
            <template slot-scope="scope">
              <span v-if="scope.row.total_available">{{
                scope.row.total_available.toLocaleString(constants.language, {
                  style: "currency",
                  currency: constants.currency,
                })
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="Valor planejado"
            width="180"
            prop="total_planned"
            sortable
          >
            <template slot-scope="scope">
              <span v-if="scope.row.total_planned">{{
                scope.row.total_planned.toLocaleString(constants.language, {
                  style: "currency",
                  currency: constants.currency,
                })
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="Valor rateado"
            width="180"
            prop="total_used"
            sortable
          >
            <template slot-scope="scope">
              <span v-if="scope.row.total_used">{{
                scope.row.total_used.toLocaleString(constants.language, {
                  style: "currency",
                  currency: constants.currency,
                })
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="Percentual realizado"
            width="200"
            prop="percent_used"
            sortable
          >
            <template slot-scope="scope">
              <el-progress
                v-if="scope.row.total_available"
                :text-inside="false"
                :stroke-width="10"
                :percentage="
                  parseFloat(formatterNumber(scope.row.percent_used))
                "
                color="#e87305"
              ></el-progress>
            </template>
          </el-table-column>
          <el-table-column
            label="Diferença"
            width="150"
            prop="diference"
            sortable
          >
            <template slot-scope="scope">
              <span v-if="scope.row.total_available">{{
                scope.row.diference
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Status" width="150">
            <template slot-scope="scope">
              <span>{{
                scope.row.status === constants.status.pending
                  ? "Aguardando rateio"
                  : scope.row.status === constants.status.closed
                  ? "Concluído"
                  : "Aberto"
              }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="font-size: 14px" v-else>
        <el-skeleton
          :rows="3"
          animated
          v-if="!finshedLoad"
          style="width: 50%"
        />
        {{
          dataTableOpen.length === 0 &&
          dataTablePending.length === 0 &&
          finshedLoad
            ? "Sem dados de rateios pendentes ou abertos para exibir."
            : ""
        }}
      </div>
    </div>
    <div class="center" style="margin-top: 25px">
      <p class="title_">Rateios concluídos</p>
      <div class="table-teste" v-if="dataTable.length > 0 && finshedLoad">
        <el-table
          :cell-style="{ cursor: 'pointer' }"
          :default-sort="{ prop: 'period', order: 'descending' }"
          :data="handleSearch"
          @sort-change="handleSort"
          style=""
          :header-cell-style="{ color: '#333' }"
          @row-click="handleRowClick"
        >
          <el-table-column label="Mês" width="100" prop="period" sortable>
            <template slot-scope="scope">
              <span>{{ dayjs(scope.row.period).format("MM/YYYY") }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="Valor disponível"
            width="180"
            prop="total_available"
            sortable
          >
            <template slot-scope="scope">
              <span v-if="scope.row.total_available">{{
                scope.row.total_available.toLocaleString(constants.language, {
                  style: "currency",
                  currency: constants.currency,
                })
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="Valor planejado"
            width="180"
            prop="total_planned"
            sortable
          >
            <template slot-scope="scope">
              <span v-if="scope.row.total_planned">{{
                scope.row.total_planned.toLocaleString(constants.language, {
                  style: "currency",
                  currency: constants.currency,
                })
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="Valor rateado"
            width="180"
            prop="total_used"
            sortable
          >
            <template slot-scope="scope" prop="total_used" sortable>
              <span v-if="scope.row.total_used">{{
                scope.row.total_used.toLocaleString(constants.language, {
                  style: "currency",
                  currency: constants.currency,
                })
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="Percentual realizado"
            width="200"
            prop="percent_used"
            sortable
          >
            <template slot-scope="scope">
              <el-progress
                v-if="scope.row.total_available"
                :text-inside="false"
                :stroke-width="10"
                :percentage="
                  parseFloat(formatterNumber(scope.row.percent_used))
                "
                color="#757575"
              ></el-progress>
            </template>
          </el-table-column>
          <el-table-column
            label="Diferença"
            width="150"
            prop="diference"
            sortable
          >
            <template slot-scope="scope">
              <span v-if="scope.row.total_available">{{
                scope.row.diference
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Status" width="150">
            <template slot-scope="scope">
              <span>{{
                scope.row.status === constants.status.pending
                  ? "Aguardando rateio"
                  : scope.row.status === constants.status.closed
                  ? "Concluído"
                  : "Aberto"
              }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <Paginator
          :pageSize="pageSize"
            :total="dataTableTemp.length"
            :start="(page - 1) * pageSize + 1"
            :end="
              page * pageSize > dataTableTemp.length
                ? dataTableTemp.length
                : (page - 1) * pageSize + pageSize
            "
            @set-page-size="setCurrentPageSize"
          />
          <el-pagination
            style="margin-right: 200px"
            :hide-on-single-page="true"
            layout="prev, pager, next"
            :total="dataTableTemp.length"
            :page-size="pageSize"
            :current-page="page"
            @current-change="setPage"
          />
        </div>
      </div>
      <div style="font-size: 14px" v-else>
        <el-skeleton
          :rows="3"
          animated
          v-if="!finshedLoad"
          style="width: 50%"
        />
        {{ finshedLoad ? "Sem dados para exibir." : "" }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import store from "../utils/store";
import api from "../utils/api";
import dayjs from "../utils/dayjs";

import constants from "../utils/constants";
import Paginator from "../components/Paginator.vue";
import sortDataTable from "../utils/sortDataTable";

export default {
  name: "LocationApportionment",
  components: {
    Paginator,
  },
  data() {
    return {
      constants: constants,
      locationId: null,
      dataTableOpen: [],
      dataTablePending: [],
      dataTableTemp: [],
      dataTable: [],
      isLoadingBtnConfirm: false,
      isLoadingBtnGenerate: false,
      dayjs: dayjs,
      btnIsDisable: true,
      finshedLoad: false,
      search: "",
      page: 1,
      pageSize: 10,
      searchColumns: [
        "percent_used",
        "period",
        "diference",
        "total_used",
        "total_available",
      ],
    };
  },
  computed: {
    ...mapGetters(["getLocationId", "formatterNumber"]),
    pagedTableData() {
      const data = this.dataTableTemp.slice(
        this.pageSize * this.page - this.pageSize,
        this.pageSize * this.page
      );
      if (data.length === 0) {
        this.page = 1;
      }
      return data;
    },
    handleSearch() {
      if (this.search.length > 0) {
        this.dataTableTemp = this.dataTable.filter((item) => {
          for (let value of this.searchColumns) {
            if (
              String(item[value])
                .toLowerCase()
                .includes(this.search.toLowerCase())
            )
              return item;
          }
        });
      } else {
        this.dataTableTemp = this.dataTable;
      }
      return this.pagedTableData;
    },
  },
  async created() {
    this.updateNavCurrentIndex("1");
    this.finshedLoad = false;
    const array_teste = store.state.navItems.map((e) => {
      if (
        e.route === "/" ||
        e.route === "/upload" ||
        e.route.match("apportionment")
      ) {
        return { ...e, disabled: false, route: "/apportionmentBylocation" };
      } else {
        return { ...e, disabled: false };
      }
    });
    this.locationId = this.getLocationId;
    this.updateNavItems_(array_teste);
    await this.getApportionments();
    this.finshedLoad = true;
  },
  watch: {
    getLocationId: function (val) {
      this.locationId = val;
      this.getApportionments();
    },
  },
  methods: {
    ...mapActions([
      "updateNavItems",
      "updateNavCurrentIndex",
      "setMenuIsDisableState",
    ]),
    setPage(val) {
      this.page = val;
    },
    setCurrentPageSize(pageSize) {
      this.setPage(1);
      this.pageSize = pageSize.size;
    },
    updateNavItems_(array_teste) {
      this.updateNavItems(array_teste);
    },
    async generateApportionment(index, row, elem) {
      this.isLoadingBtnConfirm = true;
      this.isLoadingBtnGenerate = true;
      this.setMenuIsDisableState(true);
      api
        .post("/distribution", { locale: this.locationId })
        .then(async () => {
          await this.getApportionments();
          this.$message({
            type: "success",
            message: "Novo rateio criado!",
          });
          this.setMenuIsDisableState(false);
        })
        .catch((error) => {
          this.setMenuIsDisableState(false);
          this.$message({
            type: "error",
            message: error.response.data.error,
          });
        })
        .finally(() => {
          elem.row.popVisible = false;
          this.isLoadingBtnConfirm = false;
          this.isLoadingBtnGenerate = false;
        });
    },
    handleSort(column) {
      this.dataTable = sortDataTable(this.dataTable, column);
    },
    async getApportionments() {
      this.finshedLoad = false;
      return await api
        .get("/findAllApportionments", {
          params: { locale: this.locationId },
        })
        .then((response) => {
          const { data } = response;

          let closeApportionments = [];
          let pendingApportionments = [];
          let openApportionments = [];
          let statusTable = true;

          data.map((e) => {
            const formatter = {
              ...e,
              period: e.month,
              month: this.dayjs(e.month).format("MM/YYYY"),
              percent_used: ((e.total_used / e.total_planned) * 100).toFixed(2),
              diference: (e.total_planned - e.total_used).toLocaleString(
                constants.language,
                {
                  style: "currency",
                  currency: constants.currency,
                }
              ),
            };

            if (e.status === constants.status.closed) {
              closeApportionments.push(formatter);
            } else if (e.status === constants.status.pending) {
              pendingApportionments.push(formatter);
              statusTable = true;
            } else {
              statusTable = false;
              openApportionments.push(formatter);
            }
          });

          this.btnIsDisable = statusTable;
          this.dataTableOpen = openApportionments;
          this.dataTablePending = pendingApportionments;
          this.dataTable = closeApportionments;

          this.finshedLoad = true;
        })
        .catch(() => {
          this.finshedLoad = true;
        });
    },
    handleRowClick(row) {
      this.$router.push({
        name: "apportionmentById",
        params: { id: row.id },
      });
    },
  },
};
</script>
